module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-block"
  }, [_c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "layout"
  }, [_c('h2', [_vm._v("申请联盟商家")]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "open-store"
  }, [_c('Form', {
    staticClass: "form-wrap",
    attrs: {
      "model": _vm.formItem,
      "label-width": 140
    }
  }, [_c('FormItem', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "label": "姓名："
    }
  }, [_c('Input', {
    staticClass: "s-input",
    model: {
      value: (_vm.formItem.name),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "name", $$v)
      },
      expression: "formItem.name"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "label": "商家店铺："
    }
  }, [_c('Input', {
    staticClass: "s-input",
    model: {
      value: (_vm.formItem.leagueName),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "leagueName", $$v)
      },
      expression: "formItem.leagueName"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "label": "经营类目："
    }
  }, [_c('Select', {
    attrs: {
      "size": "large",
      "placeholder": "请选择类目",
      "transfer": true
    },
    on: {
      "on-change": _vm.getStoreCat
    },
    model: {
      value: (_vm.formItem.parentId),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "parentId", $$v)
      },
      expression: "formItem.parentId"
    }
  }, _vm._l((_vm.storeCatList), function(item) {
    return _c('Option', {
      key: item.catId,
      attrs: {
        "value": item.catId
      }
    }, [_vm._v(_vm._s(item.catName))])
  }), 1), _vm._v(" "), _c('Select', {
    attrs: {
      "size": "large",
      "placeholder": "请选择子类目",
      "transfer": true
    },
    on: {
      "on-change": _vm.getStoreSonCat
    },
    model: {
      value: (_vm.formItem.catId),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "catId", $$v)
      },
      expression: "formItem.catId"
    }
  }, _vm._l((_vm.storeCatSonList), function(item) {
    return _c('Option', {
      key: item.catId,
      attrs: {
        "value": item.catId
      }
    }, [_vm._v(_vm._s(item.catName))])
  }), 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-left": "12px"
    }
  }, [_vm._v("包含范围：" + _vm._s(_vm.catDesc))])], 1), _vm._v(" "), _c('FormItem', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "label": "地区："
    }
  }, [_c('Select', {
    attrs: {
      "label-in-value": true,
      "size": "large",
      "placeholder": "请选择省份",
      "transfer": true
    },
    on: {
      "on-change": function($event) {
        return _vm.getCityList($event)
      }
    },
    model: {
      value: (_vm.formItem.provinceid),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "provinceid", $$v)
      },
      expression: "formItem.provinceid"
    }
  }, _vm._l((_vm.provinceList), function(item) {
    return _c('Option', {
      key: item.regionId,
      attrs: {
        "value": item.regionId
      }
    }, [_vm._v(_vm._s(item.localName) + "\n                  ")])
  }), 1), _vm._v(" "), _c('Select', {
    attrs: {
      "label-in-value": true,
      "size": "large",
      "transfer": true
    },
    on: {
      "on-change": function($event) {
        return _vm.getRegionList($event)
      }
    },
    model: {
      value: (_vm.formItem.cityid),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "cityid", $$v)
      },
      expression: "formItem.cityid"
    }
  }, _vm._l((_vm.cityList), function(item) {
    return _c('Option', {
      key: item.regionId,
      attrs: {
        "value": item.regionId
      }
    }, [_vm._v(_vm._s(item.localName) + "\n                  ")])
  }), 1), _vm._v(" "), _c('Select', {
    attrs: {
      "label-in-value": true,
      "size": "large",
      "transfer": true
    },
    on: {
      "on-change": function($event) {
        return _vm.getVillagesList($event)
      }
    },
    model: {
      value: (_vm.formItem.regionid),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "regionid", $$v)
      },
      expression: "formItem.regionid"
    }
  }, _vm._l((_vm.regionList), function(item) {
    return _c('Option', {
      key: item.regionId,
      attrs: {
        "value": item.regionId
      }
    }, [_vm._v(_vm._s(item.localName) + "\n                  ")])
  }), 1), _vm._v(" "), _c('Select', {
    attrs: {
      "label-in-value": true,
      "size": "large",
      "transfer": true
    },
    on: {
      "on-change": function($event) {
        return _vm.getVillage($event)
      }
    },
    model: {
      value: (_vm.formItem.villagesid),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "villagesid", $$v)
      },
      expression: "formItem.villagesid"
    }
  }, _vm._l((_vm.villagesList), function(item) {
    return _c('Option', {
      key: item.regionId,
      attrs: {
        "value": item.regionId
      }
    }, [_vm._v(_vm._s(item.localName) + "\n                  ")])
  }), 1)], 1), _vm._v(" "), _c('FormItem', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "label": "详细地址："
    }
  }, [_c('Input', {
    staticClass: "l-input",
    on: {
      "on-blur": _vm.attrChange
    },
    model: {
      value: (_vm.formItem.attr),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "attr", $$v)
      },
      expression: "formItem.attr"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "label": "地图定位："
    }
  }, [_c('baidu-map', {
    staticClass: "map",
    attrs: {
      "center": _vm.center,
      "zoom": _vm.zoom,
      "scroll-wheel-zoom": true
    },
    on: {
      "ready": _vm.handler
    }
  }, [_c('bm-marker', {
    attrs: {
      "position": _vm.positions,
      "dragging": true
    },
    on: {
      "dragend": _vm.dragend
    }
  })], 1)], 1), _vm._v(" "), _c('FormItem', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "label": "地理经度："
    }
  }, [_c('Input', {
    staticClass: "s-input",
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formItem.localX),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "localX", $$v)
      },
      expression: "formItem.localX"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "label": "地理纬度："
    }
  }, [_c('Input', {
    staticClass: "s-input",
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formItem.localY),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "localY", $$v)
      },
      expression: "formItem.localY"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "label": "手机号："
    }
  }, [_c('Input', {
    staticClass: "s-input",
    model: {
      value: (_vm.formItem.tel),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "tel", $$v)
      },
      expression: "formItem.tel"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "label": "身份证号："
    }
  }, [_c('Input', {
    staticClass: "s-input",
    model: {
      value: (_vm.formItem.idNumber),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "idNumber", $$v)
      },
      expression: "formItem.idNumber"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "label": "推荐人："
    }
  }, [_c('Input', {
    staticClass: "s-input",
    model: {
      value: (_vm.formItem.referer),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "referer", $$v)
      },
      expression: "formItem.referer"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "label": "所属市场："
    }
  }, [_c('Input', {
    staticClass: "s-input",
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.formItem.legionName),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "legionName", $$v)
      },
      expression: "formItem.legionName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "msgbox"
  }, [_c('p', [_c('em', [_vm._v("*")]), _vm._v("上传身份证照片：")]), _vm._v(" "), _c('div', {
    staticClass: "img_box"
  }, [_vm._l((_vm.idImageUrlList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "demo-upload-list"
    }, [_c('img', {
      attrs: {
        "src": item
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "demo-upload-list-cover"
    }, [_c('Icon', {
      attrs: {
        "type": "ios-eye-outline"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleView(item)
        }
      }
    }), _vm._v(" "), _c('Icon', {
      attrs: {
        "type": "ios-trash-outline"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleRemoveListId(index)
        }
      }
    })], 1)])
  }), _vm._v(" "), _c('Upload', {
    staticStyle: {
      "display": "inline-block",
      "width": "150px"
    },
    attrs: {
      "show-upload-list": false,
      "before-upload": _vm.handleBeforeUploadId,
      "on-exceeded-size": _vm.handleMaxSize,
      "on-success": _vm.handleSuccessListId,
      "on-format-error": _vm.handleFormatError,
      "format": ['jpg', 'jpeg', 'png'],
      "max-size": 2048,
      "headers": {
        'Auth-Token': _vm.upHeaders
      },
      "multiple": "",
      "type": "drag",
      "action": _vm.UploadUrl()
    }
  }, [_c('div', {
    staticStyle: {
      "width": "150px",
      "height": "150px",
      "line-height": "150px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-camera",
      "size": "40"
    }
  })], 1)])], 2)]), _vm._v(" "), _c('FormItem', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "label": "注册号/社会统一代码："
    }
  }, [_c('Input', {
    staticClass: "s-input",
    attrs: {
      "maxlength": 18
    },
    model: {
      value: (_vm.formItem.uniformSocialCreditCode),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "uniformSocialCreditCode", $$v)
      },
      expression: "formItem.uniformSocialCreditCode"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "msgbox"
  }, [_c('p', [_c('em', [_vm._v("*")]), _vm._v("上传营业执照：")]), _vm._v(" "), _c('div', {
    staticClass: "img_box"
  }, [_vm._l((_vm.licenseImageUrlList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "demo-upload-list"
    }, [_c('img', {
      attrs: {
        "src": item
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "demo-upload-list-cover"
    }, [_c('Icon', {
      attrs: {
        "type": "ios-eye-outline"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleView(item)
        }
      }
    }), _vm._v(" "), _c('Icon', {
      attrs: {
        "type": "ios-trash-outline"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleRemoveListLicense(index)
        }
      }
    })], 1)])
  }), _vm._v(" "), _c('Upload', {
    staticStyle: {
      "display": "inline-block",
      "width": "150px"
    },
    attrs: {
      "show-upload-list": false,
      "before-upload": _vm.handleBeforeUploadLicense,
      "on-exceeded-size": _vm.handleMaxSize,
      "on-success": _vm.handleSuccessListLicense,
      "on-format-error": _vm.handleFormatError,
      "format": ['jpg', 'jpeg', 'png'],
      "max-size": 2048,
      "headers": {
        'Auth-Token': _vm.upHeaders
      },
      "multiple": "",
      "type": "drag",
      "action": _vm.UploadUrl()
    }
  }, [_c('div', {
    staticStyle: {
      "width": "150px",
      "height": "150px",
      "line-height": "150px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-camera",
      "size": "40"
    }
  })], 1)])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "msgbox border_b"
  }, [_c('p', [_c('em', [_vm._v("*")]), _vm._v("上传店铺横幅照片：")]), _vm._v(" "), _c('div', {
    staticClass: "img_box"
  }, [_c('div', {
    staticClass: "demo-upload-list"
  }, [_c('Upload', {
    staticStyle: {
      "display": "inline-block",
      "width": "150px"
    },
    attrs: {
      "show-upload-list": false,
      "on-exceeded-size": _vm.handleMaxSize,
      "on-success": _vm.handleSuccessListBanner,
      "on-format-error": _vm.handleFormatError,
      "format": ['jpg', 'jpeg', 'png'],
      "max-size": 2048,
      "headers": {
        'Auth-Token': _vm.upHeaders
      },
      "type": "drag",
      "action": _vm.UploadUrl()
    }
  }, [(_vm.storeBannerImg) ? _c('img', {
    attrs: {
      "src": _vm.storeBannerImg
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "storeBannerImg",
      "value": "storeBannerUrl"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "150px",
      "height": "150px",
      "line-height": "150px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-camera",
      "size": "40"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeBannerImg),
      expression: "storeBannerImg"
    }],
    staticClass: "demo-upload-list-cover"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-eye-outline"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleView(_vm.storeBannerImg)
      }
    }
  }), _vm._v(" "), _c('Icon', {
    attrs: {
      "type": "ios-trash-outline"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleRemoveListBanner()
      }
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "msgbox"
  }, [_c('p', [_c('em', [_vm._v("*")]), _vm._v("上传店铺照片：")]), _vm._v(" "), _c('div', {
    staticClass: "img_box"
  }, [_vm._l((_vm.shopImageUrlList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "demo-upload-list"
    }, [_c('img', {
      attrs: {
        "src": item
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "demo-upload-list-cover"
    }, [_c('Icon', {
      attrs: {
        "type": "ios-eye-outline"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleView(item)
        }
      }
    }), _vm._v(" "), _c('Icon', {
      attrs: {
        "type": "ios-trash-outline"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleRemoveListShop(index)
        }
      }
    })], 1)])
  }), _vm._v(" "), _c('Upload', {
    staticStyle: {
      "display": "inline-block",
      "width": "150px"
    },
    attrs: {
      "show-upload-list": false,
      "before-upload": _vm.handleBeforeUploadShop,
      "on-exceeded-size": _vm.handleMaxSize,
      "on-success": _vm.handleSuccessListShop,
      "on-format-error": _vm.handleFormatError,
      "format": ['jpg', 'jpeg', 'png'],
      "max-size": 2048,
      "headers": {
        'Auth-Token': _vm.upHeaders
      },
      "multiple": "",
      "type": "drag",
      "action": _vm.UploadUrl()
    }
  }, [_c('div', {
    staticStyle: {
      "width": "150px",
      "height": "150px",
      "line-height": "150px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-camera",
      "size": "40"
    }
  })], 1)])], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "regis_box"
  }, [_c('input', {
    staticClass: "regis_ent",
    attrs: {
      "type": "button",
      "value": "立即申请",
      "id": "discussBtn"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit()
      }
    }
  })]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "图片预览"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [(_vm.visible) ? _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.showImageUrl
    }
  }) : _vm._e()])], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42567266"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/league-business/applyLeague.vue
// module id = 1589
// module chunks = 1